module.exports = __webpack_public_path__ + "img/Humania01.07c1a8dc.gif";